
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util} from "@util/util.js";
export default class GiftListView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        // console.log('初始数据',this._model);

        this._parentEl = this._model._parent._view._giftBoxEl;
        this._el = null;
    }
    shixiaoList(item){
        // console.log(this)
        if(item.status == 0 && (item.stockNum == 0)){
            return `<p class="receive_good_num ${item.status ? '' : 'receive_good_without'}"><span>已赠完</span></p>`
        }else if(item.status == 0 && (item.stockNum > 0)){
            return `<p class="receive_good_num"><span>已赠完</span></p>`
        }else if(item.stockNum >= 1 && item.stockNum < this._model._parent._count) {
            return `<div class="price_Red">还有${item.stockNum}件</div>`;
        }
        else {
            return ` <p class="receive_good_num">${ 'x' + this._model._parent._count }</p>`
        }
    }
    itemsdfsd(item){
        if (item.invalid) {
            return `<div class="price_Red">已赠完</div>`;
        }else  if(item.stock <= 0) {
          return `<div class="price_Red">已赠完</div>`;
        } else  if(item.stock >= 1 && item.stock < this._model._parent._count) {
            return `<div class="price_Red">还有${item.stock}件</div>`;
        }else  {
          return `<div class="price_able"><span>x</span>${item.num}</div>`
        }
      }
    initData() {
        // 一进页面把数据初始化checkstatus
        this._model._giftList.map((item2,index2)=> {
          item2.checkstatus = 0;
        })
        // 在这里处理已经选择的赠品的一进页面就自动选中
        this._model._parent._gift._data.map((item,index)=> {
          this._model._giftList.map((item2,index2)=> {
            if(item.id == item2.code && item.optionGiftFlag) {
              item2.checkstatus = 1;
              item2.num = item.num;
            }
          })
        })
      }
    showCodeIcon(item){
        return `<i class="iconfont ${item.status==0 ? item.checkstatus ?'icon-checked':'icon-disabled' : item.checkstatus ? 'icon-checked' : 'icon-uncheck'} item_checkbox" data-status="${item.status}" code="${item.code}"></i>`
        
    }
    showCodeAlready(item){
        if(!item.status){
            return `<div class="already_sold_box"></div>`
        }else{
            return ''
        }
    }
    getDefault() {
       let html = '';
       let codes = ''
       this._model._parent._gift._data.map((item,index)=>{
        codes = item.id;
           if(!item.optionGiftFlag) {
               // 默认商品
               html += `<div class="clearfix content_item ${(item.stock <= 0 || item.invalid) ? 'disable' : ''}">
               <div class="fl item_checkboxs" > 
               <span></span>
               </div>
                    <div class="fl item_img">
                      <a target="_blank" href="${this._model.goodsDetailUrl[codes]}"><img src="${item.imgUrl}"></a>
                    
                    ${this.showCodeAlready(item)}
                    </div>
                    <div class="fl item_text">
                    
                    <a target="_blank" href="${this._model.goodsDetailUrl[codes]}">   <p class="receive_good_title ${(item.stock <= 0 || item.invalid) ? 'disable' : ''}"><span class="tag">默认</span>${item.name}</p></a>
                        ${this.itemsdfsd(item)}
                    </div>
                </div>`
           }
       })
       return html;
    }
    getItems() {
        let html = '';
        let codes = ''
        html += `${this.getDefault()}`;
        this._model._giftList.map((item, index) => {
             codes = item.code;
            html += `<div class="clearfix content_item ">
            <div class="fl item_checkbox" tag="onClickChOption" data-status="${item.status}" code=${item.code}>
            ${this.showCodeIcon(item)}
            </div>
            <div class="fl item_img">
            <a target="_blank" href="${this._model.goodsDetailUrl[codes]}"><img style="opacity:${item.status==0?'0.5':'1'}" src="${item.path}"></a>
            
            ${this.showCodeAlready(item)}
            </div>
            <div class="fl item_text">
            <a target="_blank" href="${this._model.goodsDetailUrl[codes]}">   <p class="receive_good_title ${item.status ? '' : 'disable'}">${item.goodsName}</p></a>
                ${this.shixiaoList(item)}
            </div>
        </div>`
        })
        return html;
    }

    render(){
        // 初始化数据
        this.initData();
        let html = ''
        html += `<h3><i class="fr close_receive iconfont icon-close" tag="onClickIconClose"></i>选择赠品</h3>
            <div class="clearfix receive_content">
            ${
               this.getItems()
            }
            </div>
                        <div class="receive_bottom">
            <button class="le_btn le_btn_solid confirm" tag="onClickreceiveOK">确认</button>
            </div>`
        this._el = $(".receive_wrapper");
        this._el .html(html);
        // 每次render都清空选择了几件服务
        this.regEvent();
    }
    regEvent() {
        let that = this;
        this._el.off("click","[tag=onClickChOption]").on("click","[tag=onClickChOption]",function(){
            var iconfontDom = $(this).find('i.iconfont')
            var status = $(this).attr('data-status');
            if(iconfontDom.hasClass("icon-uncheck")){
                // 未选中状态 ,判断其余的是否失效 , 如果有失效就添加class
                $(this).parents().find("[tag='onClickChOption']").find('i.iconfont').each((index,item)=> {
                    // console.log('aaaaaaaaaaaaaaaaaa',$(item).attr('data-status'));
                    if($(item).attr('data-status') == 0) {
                        $(item).removeClass('icon-checked').addClass('icon-disabled')
                    } else {
                        $(this).parents().find("[tag='onClickChOption']").find('i.iconfont').removeClass('icon-checked').addClass('icon-uncheck')
                        iconfontDom.removeClass('icon-uncheck').addClass('icon-checked')
                    }
                })
            }else{
                // 当前选中状态 , 判断是否失效
                if(!status) {
                    iconfontDom.removeClass('icon-checked').addClass('icon-disabled');
                } else {
                    iconfontDom.removeClass('icon-checked').addClass('icon-uncheck')
                }
            }
        })
        this._el.off("click","[tag=onClickreceiveOK]").on("click","[tag=onClickreceiveOK]",function(){
            var selectedItem =  that._el.find("div[tag='onClickChOption'] .iconfont.icon-checked");
            if(selectedItem.length>1){
                Alert.showTip('赠品最多选择一件');
                return false
            }
            var codes = [];
            selectedItem.each(function(index,li){
                codes += $(li).attr('code')+"@";
            }); 
            if(codes.length>0){
                codes = codes.substr(0,codes.length-1);
            }else{
                codes = ''
            }
            that._model._parent.modifyItemFromCart({opsType:2,content:codes}).then(()=>{
                  if(selectedItem.length == '0') {
                    // $(that._model._parent._view._extraBoxEl.find('div.giftbox')).hide();
                  }
              }).catch(err =>{
                Alert.showTip(err);
              });
            $('.receive_wrapper').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);
        })
        this._el.off("click","[tag='onClickIconClose']").on("click","[tag='onClickIconClose']",function(){
            $('.receive_wrapper').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);
        })
    }
}

